import { TemplateRef } from '@angular/core';

export const MU_ROW_INDEX = 'muIndex';

export class TableColumn<T, U, Z = void> {
  /**
   * Label key of the column
   */
  label: string | keyof T;
  /**
   * field in T that this column store
   */
  key?: keyof T;
  /**
   * className style
   */
  className: string;
  /**
   * it is the filter name
   */
  filter: keyof U;
  /**
   * function to get the value of the column
   */
  private getValueFn: (item: T) => string;
  /**
   * filter template
   */
  filterTemplate: TemplateRef<any>;
  /**
   * filter template
   */
  editorTemplate: TemplateRef<any>;
  /**
   * filter template value
   */
  valueTemplate: TemplateRef<any>;
  /**
   * sortable column
   */
  sortable: Z;
  /**
   * reset sort on desc request
   */
  sortResetOnDesc: boolean;
  /**
   * invert sort direction
   */
  sortReverseDirection: boolean;
  /**
   * tells that the column support editing
   */
  editable: boolean;

  constructor(definition: {
    label?: string;
    key?: keyof T;
    className?: string;
    filter?: keyof U;
    getValue?: (item: T) => string;
    sortable?: Z;
    sortResetOnDesc?: boolean;
    sortReverseDirection?: boolean;
    editable?: boolean;
  }) {
    if (!(definition.label || definition.key)) {
      throw new Error('label or key is required');
    }
    this.label = definition.label || definition.key;
    this.key = definition.key;
    this.filter = definition.filter;
    this.className = (definition.className || '') + ' mu-table-cell';
    if (!this.filter) {
      this.className += ' p-table--without-filter';
    }
    this.getValueFn = definition.getValue;
    this.sortable = definition.sortable;
    this.sortResetOnDesc = definition.sortResetOnDesc;
    this.sortReverseDirection = definition.sortReverseDirection;
    this.editable = definition.editable || false;
  }
  /**
   * get the value of the column
   * @param  {T} item
   */
  getValue(item: T) {
    if (this.getValueFn) {
      return this.getValueFn(item);
    }
    if (this.key) {
      return item[this.key];
    }
    return '';
  }

  /**
   * returns if this columns use a filter or not
   * @returns boolean
   */
  get withFilter(): boolean {
    return this.filter ? true : false;
  }

  /**
   * return if column is sortable
   * @return {boolean} response
   */
  get withSort(): boolean {
    return this.sortable ? true : false;
  }
}
